import React from 'react';

export const Badge = ({ variant = 'default', children }) => {
  const styles = {
    bid: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/30',
    skip: 'bg-slate-500/10 text-slate-400 border-slate-500/30',
    partner: 'bg-amber-500/10 text-amber-400 border-amber-500/30',
    partner_required: 'bg-amber-500/10 text-amber-400 border-amber-500/30',
    register: 'bg-cyan-500/10 text-cyan-400 border-cyan-500/30',
    outreach: 'bg-indigo-500/10 text-indigo-400 border-indigo-500/30',
    default: 'bg-slate-800 text-slate-300 border-slate-700',
  };

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${styles[variant]}`}>
      {children}
    </span>
  );
};
